import React, { useState } from 'react';
import { validateCredentials, createSession } from '../utils/auth.js';
import { ActivityLogger } from '../lib/activityLogger.js';

const LOGO_PATH = `${process.env.PUBLIC_URL || ''}/JK Legacy Logos/JK Legacy Logo.png`;

export default function BasicAuth({ children, onAuthenticated }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!username || !password) {
      setError('Please enter both username and password');
      return;
    }

    const result = validateCredentials(username, password);

    if (result.isValid) {
      createSession();
      sessionStorage.setItem('jk_username', username); // Store username for Vault auth
      setIsAuthenticated(true);
      
      // Log successful login
      await ActivityLogger.login(username, 'password');
      
      if (onAuthenticated) onAuthenticated();
    } else {
      setError('Invalid credentials. Access denied.');
      setPassword('');
      
      // Log failed login attempt
      await ActivityLogger.authFailed(username, 'Invalid credentials');
    }
  };

  if (isAuthenticated) {
    return children;
  }

  return (
    <div className="auth-gate">
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <div className="auth-logo">
              <img 
                src={LOGO_PATH} 
                alt="JK Legacy" 
                style={{width: 120, height: 'auto', borderRadius: 8, marginBottom: 16}} 
              />
            </div>
            <h2 style={{ color: '#c9a62b', margin: '8px 0' }}>Welcome to JK Legacy</h2>
            <p>Secure Family Archive</p>
          </div>

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label>Username</label>
              <input
                type="text"
                value={username}
                onChange={e => setUsername(e.target.value)}
                placeholder="Enter your username"
                autoFocus
                className="rounded-full"
                style={{ borderRadius: '9999px' }}
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="rounded-full"
                style={{ borderRadius: '9999px' }}
              />
            </div>

            {error && <div className="auth-error">{error}</div>}

            <button type="submit" className="btn auth-btn rounded-full" style={{ borderRadius: '9999px' }}>
              Enter Legacy
            </button>
          </form>
        </div>

        <div className="auth-footer">
          <small>🔒 Your data is encrypted and stored locally</small>
        </div>
      </div>
    </div>
  );
}
